<template>
  <div>
    <NavBar msg="策略笔记"></NavBar>
    <div class="content" v-if="list.length > 0">
      <ul>
        <van-pull-refresh v-model="isLoading" @refresh="onRefresh">
          <van-list
            v-model="loading"
            :finished="finished"
            :finished-text="title"
            @load="onLoad"
          >
            <li v-for="(item, i) in list" :key="i" @click="goDetails(item)">
              <p>{{ item.text }}</p>
              <div>
                <span>{{ item.ctime.substr(0, item.ctime.length - 3) }}</span>
                <div class="zan" style="padiing-right: 0.08rem">
                  <img
                    src="../assets/zan.png"
                    style="width: 0.28rem"
                    alt=""
                  />{{ item.click }}赞
                </div>
              </div>
            </li>
          </van-list>
        </van-pull-refresh>
      </ul>
    </div>
    <div class="wu" v-show="show">
      <img src="../assets/bj_wu@2x.png" alt="" />
      <p>您还没有添加笔记</p>
    </div>
    <div class="add" @click.stop="addClick()">
      <img src="../assets/ic_xinzeng@2x.png" alt="" />
    </div>
  </div>
</template>

<script>
import NavBar from "@/components/NavBar.vue";
import api from "@/api/index";
import { PullRefresh, List } from "vant";
export default {
  components: { NavBar, [PullRefresh.name]: PullRefresh, [List.name]: List },
  data() {
    return {
      list: [],
      page: 1,
      isLoading: false,
      loading: false,
      finished: true,
      title: "",
      show: false,
      userId: "",
    };
  },
  created() {
    this.userId = localStorage.getItem("userId");

    this.getList();
  },
  methods: {
    onRefresh() {
      setTimeout(() => {
        this.isLoading = false;
        this.page = 1;
        this.list = [];
        this.title = "";
        this.getList();
      }, 1000);
    },
    onLoad() {
      // 异步更新数据
      // setTimeout 仅做示例，真实场景中一般为 ajax 请求
      setTimeout(() => {
        this.page++;
        // 加载状态结束
        // console.log(this.page);
        this.loading = false;
        this.getList();
        // 数据全部加载完成
        if (this.list.length >= this.total) {
          this.finished = true;
        }
      }, 1000);
    },
    getList() {
      let params = {
        accountId: this.userId,
        clientId: 1942,
        page: this.page,
        appkey: "YR176263852250001",
        pageSize: 10,
      };
      api.getTradeList(params).then((res) => {
        // console.log(res);
        if (res.code == 200) {
          this.total = res.data.total;
          this.list = this.list.concat(res.data.records);
          if (this.list.length >= this.total) {
            this.finished = true;
            this.title = "没有更多了";
          } else {
            this.finished = false;
            this.title = "";
          }
          if (this.list.length == 0) {
            this.show = true;
          } else {
            this.show = false;
          }
        }
      });
    },
    goDetails(item) {
      // console.log(item);
      let objStr = JSON.stringify(item);
      sessionStorage.setItem("item", objStr);
      this.$router.push({ path: "/bjnr" });
    },
    addClick() {
      this.$router.push({ path: "/xzbj" });
    },
  },
};
</script>

<style lang="less" scoped>
.content {
  height: 100vh;
  // overflow: hidden;
  background: #f5f5f5;
}
ul {
  padding: 0.96rem 0.32rem;
  background: #f5f5f5;
  // overflow-y: auto;
  li {
    height: 0.92rem;
    background: #fff;
    margin-top: 0.16rem;
    padding: 0.24rem 0.24rem 0.24rem 0.32rem;
    p {
      font-size: 0.3rem;
      color: #333333;
      line-height: 0.42rem;
      text-overflow: ellipsis;
      white-space: nowrap;
      overflow: hidden;
    }
    div {
      margin-top: 0.16rem;
      height: 0.34rem;
      font-size: 0.24rem;
      color: #999999;
      line-height: 0.34rem;
      display: flex;
      justify-content: space-between;
    }
  }
}
.add {
  width: 1.56rem;
  height: 1.56rem;
  position: fixed;
  bottom: 0.72rem;
  right: 0.12rem;
  img {
    width: 100%;
  }
}
.wu {
  width: 4.5rem;
  padding: 2rem 0 0 1.5rem;
  img {
    width: 4.5rem;
    height: 4rem;
  }
  p {
    text-align: center;
    margin-top: 0.44rem;
  }
}
.zan {
  display: flex;
  align-items: center;
}
</style>